import React, { useState } from 'react';

const ButtonInput = (props: any) => {
    const [id] = useState(Math.random().toString().split(".")[1]);
    const {onClick} = props

    return (
        <div className="form-group">
            <label htmlFor={id} dangerouslySetInnerHTML={{__html: props.label+":"}}></label>
            <div className="input-group mb-3">
                {props.prepend && (
                    <div className="input-group-prepend">
                        <span className="input-group-text">{props.prepend}</span>
                    </div>
                )}
                <input type={props.type || "text"} className="form-control" id={id} value={props.state} onChange={(e) => props.setState(e.target.value)} />
                
                <button className="btn btn-primary float-right" onClick={onClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                    </svg>&nbsp;
                </button>
                {props.append && (
                    <div className="input-group-append">
                        <span className="input-group-text">{props.append}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ButtonInput;